module.exports = __webpack_public_path__ + "img/c03_unitbowman_Normal_ua.696d8b10.webp";